export function isSupportQuerySelector(property) {
    return property.substr(0, 9) === '@supports';
}
//# sourceMappingURL=isSupportQuerySelector.js.map